export const passwordFormErrors = [
  {
    key: 'uppercase',
    message: 'MinUppercaseLetter'
  },
  {
    key: 'lowercase',
    message: 'MinLowercaseLetter'
  },
  {
    key: 'special-character',
    message: 'MinSpecialLetter'
  },
  {
    key: 'number',
    message: 'MinNumber'
  },
  {
    key: 'length',
    message: 'MinCharacters'
  }
];
